'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../../node_modules/classnames/index.js');
require('./Tabs.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Tab = function (props) {
    var label = props.label, onClick = props.onClick, activeTab = props.activeTab;
    var clickHandler = function () {
        onClick(label);
    };
    return (React__default['default'].createElement("li", { className: index['default']('lp__tab__list--item', activeTab === label && 'lp__tab__list--active'), onClick: clickHandler }, label));
};

exports.Tab = Tab;
//# sourceMappingURL=Tab.js.map
